import { lazy, Suspense } from "react";
import { RouteObject } from "../../helpers/tixxt-router";
import Loading from "../shared/Loading";

const EditGroup = lazy(() => import("./EditGroup"));
const NewGroup = lazy(() => import("./NewGroup"));
const GroupInvites = lazy(() => import("./Invites"));

const groupRoutes: RouteObject[] = [
  {
    path: "/groups/:groupSlug/edit",
    element: (
      <Suspense fallback={<Loading />}>
        <EditGroup />
      </Suspense>
    ),
    forceTurbo: true, // groups#edit runs profile initialization and must thus be called when accessing this route
  },
  {
    path: "/groups/new/:groupCategorySlug",
    element: (
      <Suspense fallback={<Loading />}>
        <NewGroup />
      </Suspense>
    ),
  },
  {
    path: "/invites",
    element: (
      <Suspense fallback={<Loading />}>
        <GroupInvites />
      </Suspense>
    ),
  },
];

export default groupRoutes;
